import * as types from './types';

const initialState = {
  draftFull: null,
  convertingToFull: false,
  convertingToFullSuccess: false,
  convertingToFullError: false
};

function draftFullData(state = initialState, action) {
  switch (action.type) {
    case types.CONVERT_TO_FULL:
      return {
        ...state,
        convertingToFull: true,
        convertingToFullSuccess: false,
        convertingToFullError: false
      };

    case types.CONVERT_TO_FULL_COMPLETED:
      return {
        ...state,
        draftFull: action.payload.clientSideId,
        convertingToFull: false,
        convertingToFullSuccess: true
      };

    case types.CONVERT_TO_FULL_FAILED:
      return {
        ...state,
        convertingToFull: false,
        convertingToFullError: true
      };

    default:
      return state;
  }
}

export default draftFullData;
